export class Path {
    depth: number;
    id: string;
    name: string;
}
